import { apiFetch } from "./apiClient";

/** Tipos de catálogo soportados (coincide con backend CATALOGO_TIPOS). */
export type CatalogoTipo = "rubro" | "categoria_costo";

/** Etiqueta gestionable del catálogo (rubro de maestro, categoría de costo, …). */
export interface CatalogoTag {
  id: number;
  tipo: CatalogoTipo;
  nombre: string;
  color?: string | null;
  orden: number;
  created_at?: string;
  updated_at?: string;
}

const BASE = "/catalogos";

export const catalogosApi = {
  list: (tipo: CatalogoTipo): Promise<{ success: boolean; data: CatalogoTag[] } | null> =>
    apiFetch<{ success: boolean; data: CatalogoTag[] }>(
      `${BASE}?tipo=${encodeURIComponent(tipo)}`,
      { errorMsg: "Error al cargar el catálogo" },
    ),

  create: (body: {
    tipo: CatalogoTipo;
    nombre: string;
    color?: string | null;
  }): Promise<{ success: boolean; data: CatalogoTag } | null> =>
    apiFetch<{ success: boolean; data: CatalogoTag }>(BASE, {
      method: "POST",
      body: JSON.stringify(body),
      errorMsg: "Error al crear la etiqueta",
    }),

  update: (
    id: number,
    body: Partial<{ nombre: string; color: string | null; orden: number }>,
  ): Promise<{ success: boolean; data: CatalogoTag } | null> =>
    apiFetch<{ success: boolean; data: CatalogoTag }>(`${BASE}/${id}`, {
      method: "PUT",
      body: JSON.stringify(body),
      errorMsg: "Error al actualizar la etiqueta",
    }),

  remove: (id: number): Promise<{ success: boolean } | null> =>
    apiFetch<{ success: boolean }>(`${BASE}/${id}`, {
      method: "DELETE",
      successMsg: "Etiqueta eliminada",
      errorMsg: "Error al eliminar la etiqueta",
    }),

  reorder: (
    tipo: CatalogoTipo,
    ids: number[],
  ): Promise<{ success: boolean; data: CatalogoTag[] } | null> =>
    apiFetch<{ success: boolean; data: CatalogoTag[] }>(`${BASE}/reorder`, {
      method: "PUT",
      body: JSON.stringify({ tipo, ids }),
      errorMsg: "Error al reordenar",
    }),
};
